module.exports = __webpack_public_path__ + "img/co.41244c20.svg";